import React, { useEffect, useRef } from "react";
import { Animated, Easing } from "react-native";
import type { StyleProp, ViewStyle } from "react-native";

import CategoryCard from "./CategoryCard";


interface AnimatedCategoryCardProps {
  name: string;
  icon?: string;
  description?: string;
  onPress: () => void;
  index: number;
  style?: StyleProp<ViewStyle>;
  [key: string]: unknown;
}

const AnimatedCategoryCard: React.FC<AnimatedCategoryCardProps> = ({
  name,
  icon,
  description,
  onPress,
  index,
  style,
  ...rest
}) => {
  console.log("AnimatedCategoryCard: Rendering animated card for:", name, "at index:", index);
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const translateY = useRef(new Animated.Value(30)).current;

  useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 500,
      delay: index * 80,
      useNativeDriver: true,
      easing: Easing.out(Easing.ease),
    }).start();
    Animated.timing(translateY, {
      toValue: 0,
      duration: 500,
      delay: index * 80,
      useNativeDriver: true,
      easing: Easing.out(Easing.ease),
    }).start();
  }, [fadeAnim, translateY, index]);

  return (
    <Animated.View
      style={{
        opacity: fadeAnim,
        transform: [{ translateY }],
      }}
    >
      <CategoryCard
        name={name}
        icon={icon}
        description={description}
        onPress={onPress}
        style={style}
        {...rest}
      />
    </Animated.View>
  );
};

export default AnimatedCategoryCard;
